import { render, staticRenderFns } from "./NewsPopular.vue?vue&type=template&id=3bd0714f"
import script from "./NewsPopular.vue?vue&type=script&lang=js"
export * from "./NewsPopular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports